$(document).ready(function() {
    $(window).on('scroll', function() {
        if($(document).scrollTop() > $('.page-header').get(0).getBoundingClientRect().bottom) {
            $('.page-header').addClass('page-header--fixed');
            $('body').addClass('body--fixed');
            $('.back-to-top').fadeIn();
        } else {
            $('.page-header').removeClass('page-header--fixed');
            $('body').removeClass('body--fixed');
            $('.back-to-top').fadeOut();
        }
    });
    $(window).trigger('scroll');
});